var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-cover",on:{"click":_vm.onClose}},[_c('img',{staticClass:"img",attrs:{"src":require("@/assets/img/payment_callback_pic.jpg"),"alt":""}}),_c('iframe',{attrs:{"hidden":"","src":"/pay-cb.html"}})])}
var staticRenderFns = []

export { render, staticRenderFns }